export default __webpack_public_path__ + "static/media/image.c5a75660.png";